__webpack_require__.p = "/heroesList-with-change-function/";